import { type GooglePlaceDetails } from 'data/v3/data-contracts';

export const getAddressComponent = (
  // eslint-disable-next-line default-param-last
  addressComponents: GooglePlaceDetails['placeDetails']['addressComponents'] = [],
  targets: string[],
  joiner = ' ',
) => {
  return addressComponents
    .map((addressComponent) => {
      return targets.map((target) => {
        if (addressComponent.types.includes(target)) {
          return addressComponent.shortText;
        }

        return null;
      });
    })
    .flat()
    .filter((addressComponent) => addressComponent)
    .join(joiner);
};
